
import { Component, Vue, Prop, Watch } from "vue-property-decorator";
import ChannelService from "@/services/lead/ChannelService";
import DateRangePicker from "vue2-daterange-picker";
import LeadService from "@/services/leadService";
import Multiselect from "vue-multiselect";
import LeadTabulationService from "@/services/lead/LeadTabulationService";
import PaymentService from "@/services/lead/PaymentService";
import WineService from "@/services/integration/WineService";
import BVService from "@/services/integration/BVService";
import CouponService from "@/services/lead/CouponService";
import ProductService from "@/services/lead/ProductService";
import StatusService from "@/services/lead/StatusService";
import CpaService from "@/services/lead/CpaService";
import { Money } from "v-money";
import vSelect from "vue-select";
import { error } from "jquery";
import moment from "moment-timezone";

@Component({
  components: {
    DateRangePicker,
    Multiselect,
    vSelect,
    Money,
  },
})
export default class AttendanceForm extends Vue {

  private dateScheduling = {
    startDate: "",
    endDate: ""
  }

  @Watch("dateScheduling.startDate")
  onChangeRangeScheduling(value: any, _oldValue: any) {
    this.leadHistory.date_scheduling = value;
  }

  private dateRangeRenovation = {
    startDate: "",
    endDate: ""
  }
  @Watch("dateRangeRenovation.startDate")
  onChangeRenovationDate(value: any, _oldValue: any) {
    this.leadHistory.date_renovation = value;
  }

  private dateRangeSale = {
    startDate: "",
    endDate: ""
  }
  @Watch("dateRangeSale.startDate")
  onChangeSaleDate(value: any, _oldValue: any) {
    this.leadHistory.date_sale = value;
  }


  @Watch("wsUpgradePlanRes")
  onUpgradePlanRes(val: any) {
    if (val.status === "confirmationNeeded") {
      this.loading = false;
      this.$bvModal
        .msgBoxConfirm(
          "Existe um upgrade para este Lead, deseja enviar outro mesmo assim?",
          {
            title: "Confirmação de upgrade",
            size: "md",
            buttonSize: "md",
            okVariant: "secondary",
            okTitle: "Enviar",
            cancelTitle: "Cancelar",
            cancelVariant: "cancel-modal",
            footerClass: "clever-skin p-2",
            hideHeaderClose: true,
            centered: true,
          }
        )
        .then((value) => {
          if (value) {
            this.wineUpgradePlan(true);
          }
        })
        .catch((err) => {
          console.error(err)
        });
    }
    if (val.status === "pending") {
      this.$store.commit("navBarAlert/DANGER_ALERT", val.message);
    }
    if (val.status === "error") {
      this.loading = false;
      this.$store.commit("navBarAlert/DANGER_ALERT", val.message);
    }
    if (val.status === "warning") {
      this.loading = false;
      this.$store.commit("navBarAlert/DANGER_ALERT", val.message);
    }
    if (val.status === "success") {
      this.$store.commit("navBarAlert/SUCCESS_ALERT", val.message);
      setTimeout(() => {
        this.$router.push("/leads");
      }, 2000);
      this.loading = false;
    }
  }

  @Watch("selectedCardBrand")
  onChangeCardBrand(newObject: any) {
    this.bvCards.forEach(
      (brandObj) => {
        if (brandObj.name == newObject.name) {
          this.cardVariantsList = brandObj.variants
        }
      }
    )
    this.selectedCardVariant = ''
  }

  @Watch("selectedCardVariant")
  onChangeCardVariant(newObject: any) {
    this.cardVariantsList.forEach(
      (variantObj) => {
        if (variantObj.code == newObject.code) {
          this.cardInsuranceList = variantObj.insurance
        }
      }
    )
    this.selectedHolderCardInsurance = ''
    if (this.leadHistory.additional_card && this.leadHistory.additional_card.name > 0) {
      for (let i = 1; i <= this.leadHistory.additional_card.name; i++) {
        if (!!this.leadHistory['insurance_additional_' + i]) {
          this.leadHistory['insurance_additional_' + i] = ''
        }
      }
    }
  }

  @Watch("homeState")
  onHomeStateChange() {
    this.homeCitiesList = this.loadCities(this.homeState.index)
    this.lead.content.state = this.homeState.name
    if (this.lead.content.state.toUpperCase() != this.homeState.name) {
      this.homeCity = ''
    }
  }

  @Watch("deliveryState")
  onDeliveryStateChange() {
    this.deliveryCitiesList = this.loadCities(this.deliveryState.index)
    this.deliveryCity = ''
  }

  @Watch("leadHistory.tabulation")
  onTabulationStateChange() {
    this.setMandatoryFields()
  }

  @Watch("leadHistory.insurance")
  onInsuranceStateChange() {
    if (this.$auth.user().platform_name === 'bv-fgts-sales') {
      this.setMandatoryFields()
    }
  }

  private get wsUpgradePlanRes() {
    return this.$store.state.socket.upgradePlanRes;
  }

  @Prop(Number) private idLead?: number;

  private loading: boolean = true;
  private loadingWineRes: boolean = false;
  private loadingCheckOfferRes: boolean = false;
  private limitDateSale  = this.$moment().format('YYYY-MM-DD HH:mm:ss');
  private limitDateAttendance  = this.$moment().add(-1, 'day').format('YYYY-MM-DD HH:mm:ss');

  private verticalVarejo = [
    "animale" , "fabula" , "souq" , "abrand" , "mariafilo" , "crisbarros" , "aviva" , "farm" , "mobonline" , "mrcat" , "offpremium" , "stz", "youcom", "dzarm", "lucidez", "cantu", "pneustore"
  ]

  private bvCardPlatforms: string[] = ['bv', 'bv-cartoes']
  private isBvCardPlatform: boolean = this.bvCardPlatforms.includes(this.$auth.user().platform_name);

  private requiredInputActionBV = ["venda", "abandono-checkout" , "whatsapp-receptivo"]

  private leadService: LeadService = new LeadService();
  private wineService: WineService = new WineService();
  private couponService: CouponService = new CouponService();
  private bvService: BVService = new BVService();

  private ufList: any[] = [];
  private ufcities: any;
  private simpleStatesAndCities: any[] = [];
  private bvInvoiceDates: any[] = [];
  private bvOccupationCodes: any[] = [];
  private bvCards: any;
  private nationalitiesList: any[] = [];

  private lead: any = null;
  private leadHistory: any = {
    date_renovation: "",
    date_scheduling: "",
    date_sale: "",
    channel: null,
    payment: null,
    product: null,
    status: null,
    tabulation: null,
    value: 0,
    order: null,
    cpf: null,
    note_internal: null,
    installment: null,
    number_student: null,
    coupon: null,
  };
  private editing: boolean = false;
  private channels: [any?] = [];
  private paymentMethods: [any?] = [];
  private products: [any?] = [];
  private status: [any?] = [];
  private tabulations: [any?] = [];
  private coupons: [any?] = [];
  private valueCPA:any = null;
  private typeCPA:any = null;
  private discount_rate:any = null;
  private nameDisabled: boolean = true;
  private cpfDisabled:boolean = true;
  private cnpjDisabled:boolean = true;
  private phoneDisabled:boolean = true;
  private emailDisabled:boolean = true;

  private bvCheckOfferResponse: any = '';
  private bvCheckOfferAvailableCards: [] = [];

  private birthDate: any = '';
  private homeAddressObj: any = [];
  private deliveryAddressObj: any = [];
  private homeStreetName: any = '';
  private homeNumber: any = '';
  private homeComplement: any = '';
  private homeNeighborhood: any = '';
  private homeState: any = '';
  private homeCity: any = '';
  private birth_state: any = '';
  private birth_city: any = '';
  private homeMailAddressFlag: boolean = true;
  private confirmationCheckbox: boolean = false;
  private deliveryZipcode: any = '';
  private deliveryStreetName: any = '';
  private deliveryNumber: any = '';
  private deliveryComplement: any = '';
  private deliveryNeighborhood: any = '';
  private deliveryState: any = '';
  private deliveryCity: any = '';
  private occupation: any = {label: '', name: 0};
  private professionalType: any = {label: '', name: 0};
  private cardBrandsList: any[] = [];
  private cardVariantsList: any[] = [];
  private cardInsuranceList: any[] = [];
  private selectedCardBrand: any = '';
  private selectedCardVariant: any = '';
  private selectedHolderCardInsurance: any = '';
  private additionalCardsList: any = {};

  private homeCitiesList: any[] = [];
  private deliveryCitiesList: any[] = [];

  private modalTabulation: any = {};

  private mandatoryFields: string[] | [] = [];

  private moneyMask: any = {
    decimal: ",",
    thousands: ".",
    prefix: "",
    suffix: "",
    precision: 2,
    masked: true /* doesn't work with directive */,
  };

  private formPurchase = [
        {label: this.$auth.user().platform_name === "dzarm" ?
            'Cliente usou o link do site' : this.$auth.user().platform_name !== "youcom" ?
             'Cliente usou o link do carrinho' :
             'Cliente usou o link', name: 'cart_link'},
        {label: 'Sistema administrativo', name: 'adm_system'},
        this.$auth.user().platform_name !== "wine" ? {label: 'Venda assistida', name: 'assisted_sale'} : '',
        {label: 'Cupom WeClever', name: 'weclever_coupon'},
        {label: 'Aplicativo', name: 'app'},
        {label: 'Não tagueada', name: 'not_tagged'},
        {label: 'Outro (especificar nas observações internas)', name: 'other'}
    ]

    private formPurchasePetiko = [
        {label: 'Link WeClever', name: 'weclever_link'},
        {label: 'Cupom WeClever', name: 'weclever_coupon'},
        {label: 'Venda assistida', name: 'assisted_sale'},
        {label: 'Boleto gerado pelo consultor', name: 'billet_generated_by_the_consultant'},
    ]

  private refusalFinancingOptions = [
        {name: "[APNP] Apenas Cartão", label: "[APNP] Apenas Cartão"},
        {name: "[APNP] Fez financiamento com a BV", label: "[APNP] Fez financiamento com a BV"},
        {name: "[APNP] Fez financiamento com outro Banco", label: "[APNP] Fez financiamento com outro Banco"},
        {name: "[APNP] Cliente ainda não decidiu", label: "[APNP] Cliente ainda não decidiu"},
        {name: "[APNP] Taxa do BV maior que outros bancos", label: "[APNP] Taxa do BV maior que outros bancos"},
        {name: "[APNP] Relatou problemas com a loja", label: "[APNP] Relatou problemas com a loja"},
        {name: "[APNP]Desconhece a simulação do financiamento", label: "[APNP]Desconhece a simulação do financiamento"},
        {name: "[APNP] Interesse em fechar financiamento", label: "[APNP] Interesse em fechar financiamento"},
        {name: "[APNP] Não sabe informar pois foi feito pelo cônjuge", label: "[APNP] Não sabe informar pois foi feito pelo cônjuge"},
  ]

  private clickedOnUpgradeButton?: boolean;
  private clickedOnPropositionButton?: boolean;
  private clickedOnCheckOffer?: boolean = false;

  private pscProfessions: any;

  private get isWineUpgradePlan() {
    return ['wine', 'wine-upgrade', 'wine-reconquista', 'wine-refidelizacao', 'wine-cobranca'].includes(this.$auth.user().platform_name) &&
        this.leadHistory.product && Array.isArray(this.leadHistory.product) &&
        this.leadHistory.product.length > 0 && ["upgrade", "refidelizacao"].includes(this.leadHistory.product[0].action_name) &&
        this.leadHistory.status && this.leadHistory.status.name == "lead_finished_sale";
  }

  private get isWineAbandonoCaptacao() {
    return this.$auth.user().platform_name == "wine" &&
        this.leadHistory.product && Array.isArray(this.leadHistory.product) &&
        this.leadHistory.product.length > 0 && ["abandono", "captacao"].includes(this.leadHistory.product[0].action_name) &&
        this.leadHistory.status && this.leadHistory.status.name == "lead_finished_sale";
  }

  // only enable "R$" edit option: sale && listed platforms
  private get getMoneyEnabled() {
    return !((this.leadHistory.status &&
        this.leadHistory.status.name &&
        this.leadHistory.status.name === 'lead_finished_sale'
      ) &&
      ['taglivros'].includes(this.$auth.user().platform_name)
    )
  }

  private getCoupons() {
    if (
      this.leadHistory.status.name == "lead_finished_sale"
    ) {
      // get coupons
      this.couponService.indexStatus("coupon_active").then(
        (response) => {
          if (response) {
            for (let coupon of response.body) {
              coupon.name = coupon.code;
              delete coupon.code;
            }
            this.coupons = response.body;
            this.leadHistory.coupon = null;
          }
        },
        (error) => {
          console.error(error);
        }
      );
    }
  }

  private statusChanged(status: any) {
    if (this.leadHistory.channel != null) {
      let leadTabulationService: LeadTabulationService = new LeadTabulationService();
      leadTabulationService
        .indexAllFilters(
          17,
          this.leadHistory.status.id_status,
          this.leadHistory.channel.id_channel
        )
        .then((response) => {
          this.tabulations = response;
          this.leadHistory.tabulation = null;
        });
      this.getCoupons();
    }
  }

  private couponChanged(coupon: any) {
    let discount = 0;
    let value = 0;
    this.discount_rate = 0;

    for (let product of this.leadHistory.product) value += product.price;
    this.leadHistory.value = value;
    this.discount_rate = parseFloat(coupon.discount_rate || 0);

    discount = parseFloat(this.leadHistory.value) * this.discount_rate;
    if(this.discount_rate !== 0)
        this.leadHistory.value = (parseFloat(this.leadHistory.value) - discount).toFixed(2);
  }

  private channelChanged(channel: any) {
    if (this.leadHistory.status != null) {
      let leadTabulationService: LeadTabulationService = new LeadTabulationService();
      leadTabulationService
        .indexAllFilters(
          17,
          this.leadHistory.status.id_status,
          this.leadHistory.channel.id_channel
        )
        .then((response) => {
          this.tabulations = response;
          this.leadHistory.tabulation = null;
        });
      this.getCoupons();
    }
  }

  private productSelected() {
    let sum: number = 0;
    for (let product of this.leadHistory.product) sum += product.price;
    this.leadHistory.value = sum;

    if(this.discount_rate !== 0){
        let discount = parseFloat(this.leadHistory.value) * this.discount_rate;
        this.leadHistory.value = parseFloat(this.leadHistory.value) - discount;
    }
  }

  private newProduct(name: string) {
    let newProduct = {
      id_product: -Math.floor(Math.random() * 10000000),
      description: name,
      price: 0,
      fk_id_platform: this.$auth.user().id_platform,
    };
    if (this.leadHistory.product == null) this.leadHistory.product = [];
    this.products.push(newProduct);
    this.leadHistory.product.push(newProduct);
  }

  private editLead(fild:boolean){
      let params = {
        id_lead:this.lead.id_lead,
        id_platform:this.lead.id_platform,
        action: this.lead.action_name,
        name: this.lead.name,
        cpf:this.lead.cpf,
        cnpj: this.lead.cnpj,
        phone:this.lead.phone,
        email:this.lead.email,
      }

      if(!fild){
          this.leadService.editLead(params).then(result => {
            if(result.message ===  "Success update Lead!"){
                return this.$store.commit("navBarAlert/SUCCESS_ALERT", "Lead editado com sucesso!");
            }else{
                return this.$store.commit("navBarAlert/DANGER_ALERT",
                `Error: Ocorreu um erro ao editar o lead, tente novamente.`);
            }
        });
      }
  }

  private get isProductInvalid() {
    return false;
  }

  private get isFinishedSale() {
    return this.leadHistory &&
      this.leadHistory.status &&
      this.leadHistory.status.name == "lead_finished_sale"
  }

  private get isSaleActionName() {
    return this.lead && this.lead.action_name === 'venda'
  }

  private get isBvProposition() {
    return this.isBvCardPlatform
    // &&
    // [
    //   'venda',
    //   'whatsapp-receptivo',
    //   'abandono-checkout',
    //   'dotz-abandono-checkout',
    //   'dotz-whatsapp-receptivo',
    //   'apnp'
    // ].includes(this.lead.action_name)
  }


  private wineUpgradePlan(newUpgradeConfirmation: boolean = false) {
    if (
      !this.leadHistory.product[0].attribute_data ||
      !this.leadHistory.product[0].attribute_data.quantityCredits ||
      !this.leadHistory.product[0].attribute_data.newAdvantageType ||
      !this.leadHistory.product[0].attribute_data.quantityBottles ||
      !this.leadHistory.product[0].attribute_data.modality
    ) {
      this.loading = false;
      return this.$store.commit("navBarAlert/DANGER_ALERT",
        `Error: cadastro do produto (${this.leadHistory.product[0].description}) incompleto.`);
    }

    if (!this.lead.platform_lead_id) {
      this.loading = false;
      return this.$store.commit("navBarAlert/DANGER_ALERT",
        `Error: lead nao contém id da plataforma em nossa base de dados.`);
    }
    if (!this.leadHistory.installment) {
      this.loading = false;
      return this.$store.commit("navBarAlert/DANGER_ALERT",
        `Error: Informar a quantidade de parcelas`);
    }
    this.leadHistory.idLead = this.idLead;
    let params: any = {
      platform_lead_id: this.lead.platform_lead_id,
      coupon: this.leadHistory.coupon && this.leadHistory.coupon.name ? this.leadHistory.coupon.name : null,
      quantityCredits: Number(
        this.leadHistory.product[0].attribute_data.quantityCredits
      ),
      installment: Number(this.leadHistory.installment),
      newAdvantageType: this.leadHistory.product[0].attribute_data
        .newAdvantageType,
      quantityBottles: Number(
        this.leadHistory.product[0].attribute_data.quantityBottles
      ),
      modality: this.leadHistory.product[0].attribute_data.modality,
      newUpgradeConfirmation: newUpgradeConfirmation,
      formFields: this.leadHistory
    };
    this.loadingWineRes = true
    this.wineService.wineUpgradePlan(params)
      .then(() => {this.loadingWineRes = false})
      .catch((err) => {
        this.loadingWineRes = false;
        console.error(err)
      });
    // Wine lead tabulation window becomes simple "loading" for x milliseconds:
    setTimeout(() => {
      this.loading = false;
    }, 2000);
  }

  private bvCheckOffer() {
    this.clickedOnCheckOffer = true
    this.loadingCheckOfferRes = true

    let bvCheckOfferParams: any;

    if (this.isValidBvCheckOfferParams()) {
      bvCheckOfferParams = {
        cpf: this.lead.cpf,
        income: parseInt(String(this.lead.content.income).replace(/[^0-9,-]+/g,"")),
        occupationCode: parseInt(this.occupation.name),
        birthDate: moment(this.birthDate, 'DD/MM/YYYY').format('YYYY-MM-DD')
      }
    } else {
      this.loadingCheckOfferRes = false
      return false
    }

    let response: any = this.bvService.bvCheckOffer(this.lead.id_lead, bvCheckOfferParams)
    .then(result => {
      this.loadingCheckOfferRes = false
      if (result.status == 200) {
        this.bvCheckOfferResponse = result
        this.bvCheckOfferAvailableCards = this.bvCheckOfferResponse.body.retorno.resultado.produtoCartoesDisponiveis

        // Save check offer attributes on lead.content
        this.lead.content.offer_decision = this.bvCheckOfferResponse.body.retorno.resultado.decisao
        this.lead.content.calculated_limit = this.bvCheckOfferResponse.body.retorno.resultado.limiteCalculado
        this.lead.content.offer_expiry_date = this.bvCheckOfferResponse.body.retorno.resultado.vigenciaOferta
      }
    })
    .catch(err => {
      this.loadingCheckOfferRes = false
      console.error(err)
      this.$store.commit("navBarAlert/DANGER_ALERT", `Erro ${err.status}: ${err.body}: por favor, tente novamente`)
    })
  }

  private bvProposition() {

    this.processAdditionalCards()

    this.lead.content.birth_date = moment(this.birthDate, 'DD/MM/YYYY').format('YYYY-MM-DD')

    this.lead.content.address = this.homeStreetName
    this.lead.content.number = this.homeNumber
    this.lead.content.neighborhood = this.homeNeighborhood
    this.lead.content.complement = this.homeComplement
    this.lead.content.state = this.homeState
    this.lead.content.birth_city = this.leadHistory.birth_city
    this.lead.content.birth_state = this.leadHistory.birth_state
    this.lead.content.city = this.homeCity
    this.lead.content.cc_brand = this.selectedCardBrand
    this.lead.content.cc_variant = this.selectedCardVariant
    this.lead.content.insurance_safe = this.selectedHolderCardInsurance ? this.selectedHolderCardInsurance : null

    this.lead.content.home_delivery_flag = this.homeMailAddressFlag

    this.homeAddressObj = {
      zipcode: this.lead.content.zipcode,
      streetName: this.homeStreetName,
      number: this.homeNumber,
      neighborhood: this.homeNeighborhood,
      complement: this.homeComplement,
      city: this.lead.content.city,
      state: this.lead.content.state,
    }

    if (this.homeMailAddressFlag === true) {
      this.deliveryAddressObj = this.homeAddressObj
    } else {
      this.deliveryAddressObj = {
        zipcode: this.deliveryZipcode,
        streetName: this.deliveryStreetName,
        number: this.deliveryNumber,
        neighborhood: this.deliveryNeighborhood,
        complement: this.deliveryComplement,
        state: this.deliveryState,
        city: this.deliveryCity,
      }

      this.lead.content.delivery_address = this.deliveryStreetName
      this.lead.content.delivery_number = this.deliveryNumber
      this.lead.content.delivery_neighborhood = this.deliveryNeighborhood
      this.lead.content.delivery_complement = this.deliveryComplement
      this.lead.content.delivery_state = this.deliveryState
      this.lead.content.delivery_city = this.deliveryCity
    }

    if (String(this.lead.content.sex).toUpperCase() === 'M') {
      this.lead.content.sex = {label: 'M', name: 'M'}
    } else if (String(this.lead.content.sex).toUpperCase() === 'F') {
      this.lead.content.sex = {label: 'F', name: 'F'}
    }

    let bvParams = {
      fingerprint: this.lead.content.fingerprint,
      name: this.lead.name,
      motherName: this.lead.content.mother_name,
      sex: this.lead.content.sex.name,
      occupationCode: String(this.occupation.name),
      birthDate: moment(this.birthDate, 'DD/MM/YYYY').format('YYYY-MM-DD'),
      professionalTypeCode: String(this.professionalType.name),
      cpfNumber: this.lead.cpf,
      rgNumber: this.lead.content.rg,
      email: this.lead.email,
      homeMailAddressFlag: this.homeMailAddressFlag,
      homeAddress: this.homeAddressObj,
      deliveryAddress: this.deliveryAddressObj,
      income: this.lead.content.income,
      cellPhone: this.lead.phone,
      homePhone: this.lead.content.home_phone,
      invoiceDay: this.leadHistory.invoice_date.name,
      ccBrandCode: this.selectedCardBrand.code,
      ccVariantCode: this.selectedCardVariant.code,
      holderCardInsuranceCode: this.selectedHolderCardInsurance ? this.selectedHolderCardInsurance.code : null,
      additionalCardsNumber: this.leadHistory.additional_card ? this.leadHistory.additional_card.name : null,
      addCardsAttributes: this.additionalCardsList ? this.additionalCardsList : null,
      nationality: this.leadHistory.nationality ? this.leadHistory.nationality : null,
      politicallyExposed: this.leadHistory.politically_exposed ? this.leadHistory.politically_exposed : null,
    }

    let bvResponse: any = this.bvService.bvProposition(this.idLead, bvParams)
      .then(result => {
        if (result.status == 200) {
          this.saveHistory()
          return this.$store.commit("navBarAlert/SUCCESS_ALERT", result.body);
        }
      })
      .catch(err => {
        this.loading = false
        console.error(err)
        this.$store.commit("navBarAlert/DANGER_ALERT", `Erro ${err.status}: ${err.body}: por favor, tente novamente`)
      })
  }

  private loadCities(stateIndex) {
    try {
      return this.ufcities.states[stateIndex].cities
    } catch (err) {
      return []
    }
  }

  private isValidBirthDate(birthDate) {
    if (this.birthDate.length === 10 && moment(this.birthDate, 'DD/MM/YYYY', true).isValid()) {
      return true
    } else {
      return false
    }
  }

  private isValidBvCheckOfferParams() {
    if (this.lead &&
    this.lead.cpf &&
    this.isValidIncome(this.lead.content.income) &&
    this.occupation &&
    this.occupation.name &&
    this.isValidBirthDate(this.birthDate)
    ) {
      return true
    } else {
      return false
    }
  }

  private isValidIncome(income) {
    if (parseFloat(String(income).replace(/[^0-9,-]+/g, '')) <= 0) {
      return false;
    } else {
      return true;
    }
  }

  private isValidSaleValue(saleValue) {
    if (this.leadHistory &&
    this.leadHistory.status &&
    this.leadHistory.status.name == "lead_finished_sale" &&
    parseFloat(String(saleValue).replace(/[^0-9,-]+/g, '')) <= 0) {
      return false
    } else {
      return true;
    }
  }

  private saveHistory(save: boolean = false) {
    if(this.modalTabulation.id_lead){
        this.leadHistory.id_lead_duplicated = this.modalTabulation.id_lead;
        this.leadHistory.reason = this.modalTabulation.attribute_name;
    }

    this.leadHistory.save = save;
    this.loading = true;

    if (this.isBvCardPlatform && !!this.isBvProposition) {
      try {
        this.leadHistory = {
          ...this.leadHistory,
          sex: this.lead.content.sex ? this.lead.content.sex.name : null,
          mother_name: this.lead.content.mother_name,
          rg: this.lead.content.rg,
          home_phone: this.lead.content.home_phone,
          income: this.lead.content.income,
          birth_date: moment(this.birthDate, 'DD/MM/YYYY').format('YYYY-MM-DD'),
          occupation: this.occupation && this.occupation.label ? this.occupation.label : null,
          professional_type: this.professionalType ? this.professionalType.label : null,
          zipcode: this.lead.content.zipcode,
          address: this.homeStreetName,
          number: this.homeNumber,
          neighborhood: this.homeNeighborhood,
          complement: this.homeComplement,
          state: this.homeState,
          birth_city: this.birth_city,
          birth_state: this.birth_state,
          city: this.homeCity,
          home_delivery_flag: this.homeMailAddressFlag,
          cc_brand: this.selectedCardBrand,
          cc_variant: this.selectedCardVariant,
          insurance_safe: this.selectedHolderCardInsurance,
          nationality: this.leadHistory.nationality ? this.leadHistory.nationality : null,
          politically_exposed: this.leadHistory.politically_exposed ? this.leadHistory.politically_exposed : null,
        }

        this.processAdditionalCards()

        if (this.homeMailAddressFlag === false) {
          this.leadHistory = {
            ...this.leadHistory,
            delivery_zipcode: this.deliveryZipcode,
            delivery_address: this.deliveryStreetName,
            delivery_number: this.deliveryNumber,
            delivery_neighborhood: this.deliveryNeighborhood,
            delivery_complement: this.deliveryComplement,
            delivery_state: this.deliveryState,
            delivery_city: this.deliveryCity,
          }
        }
      } catch (error) {
        console.error(error)
        this.$store.commit("navBarAlert/DANGER_ALERT", `Erro ao salvar conteúdo do lead history: ${error}`);
      }
    }

    this.leadService
      .newHistory(this.idLead!, this.leadHistory)
      .then((response) => {
        if(response.id_lead){
          this.loading = false;
          this.modalTabulation = response;
          this.$bvModal.show('modal-verify');
          return;
        }

        this.$bvModal.hide('modal-verify');
        if (JSON.stringify(response).includes("success")) {
          if (this.leadHistory.status.id_status == 3)
            this.$bus.$emit("commission_refresh", {});
          this.$store.commit("navBarAlert/SUCCESS_ALERT", "Atendimento salvo com sucesso!");
        } else {
          this.$store.commit("navBarAlert/DANGER_ALERT", `Error: ${response}`);
        }
        this.leadHistory = {
          date_renovation: "",
          date_scheduling: "",
          date_sale: "",
          phone: null,
          children: null,
          children_age: null,
          channel: null,
          payment: null,
          product: null,
          status: null,
          tabulation: null,
          value: 0,
          order: null,
          cpf: null,
          note_internal: null,
          installment: null,
          number_student: null,
          reason: null,
        };
        setTimeout(() => {
          this.$router.push("/leads");
        }, 2000);
        this.loading = false;
      });
  }

  // push additional credit cards into leadHistory and
  // additionalCardsList (which will go to bvParams api)
  private processAdditionalCards() {
    if (!!this.leadHistory.additional_card) {
      for (let i = 1; i <= this.leadHistory.additional_card.name; i++) {
        const nameKey = `name_additional_${i}`
        const cpfKey = `cpf_additional_${i}`
        const birthDateKey = `birth_date_additional_${i}`
        const insuranceKey = `insurance_additional_${i}`

        const additionalName = eval(`this.leadHistory.name_additional_${i}`)
        const additionalCpf = String(eval(`this.leadHistory.cpf_additional_${i}`))
        const additionalBirthDate = String(eval(`this.leadHistory.birth_date_additional_${i}`))
        const additionalInsurance = eval(`this.leadHistory.insurance_additional_${i}`)

        if (!!additionalName && !!additionalCpf && !!additionalBirthDate) {
          this.additionalCardsList[nameKey] = additionalName
          this.leadHistory[nameKey] = additionalName

          this.additionalCardsList[cpfKey] = additionalCpf
          this.leadHistory[cpfKey] = additionalCpf

          this.additionalCardsList[birthDateKey] = additionalBirthDate
          this.leadHistory[birthDateKey] = additionalBirthDate

          if (!!additionalInsurance && !!additionalInsurance.label && !!additionalInsurance.code) {
            this.leadHistory[insuranceKey] = additionalInsurance.label
            this.additionalCardsList[insuranceKey] = additionalInsurance.code
          }
        }
      }
    }
  }

  private setMandatoryFields() {
    const platform = this.$auth.user().platform_name

    if (
      platform === 'portosegurocartoes' &&
      this.leadHistory &&
      this.leadHistory.status &&
      this.leadHistory.status.name === 'lead_finished_sale' &&
      this.leadHistory.tabulation &&
      this.leadHistory.tabulation.name === 'Conversão coleta de dados'
    ) {
      this.mandatoryFields = [
        'sex',
        'mother_name',
        'professional_type',
        'occupation',
        'income',
        'birth_date',
        'cpf_additional_1',
        'name_additional_1',
        'email2',
        'birth_state',
        'birth_city',
        'zipcode',
        'address',
        'number',
        'complement',
        'neighborhood',
        'state',
        'city',
        'receive_email',
        'receive_sms',
        'receive_invoice_by_email',
        'invoice_date'
      ]

    } else if (
      platform === 'neon-fgts' &&
      this.leadHistory &&
      this.leadHistory.status &&
      this.leadHistory.status.name === 'lead_finished_sale'
    ) {
      this.mandatoryFields = [
        'order'
      ]

    } else if (
      platform === 'bv-fgts-sales' &&
      this.leadHistory &&
      this.leadHistory.status &&
      this.leadHistory.status.name === 'lead_finished_sale'
    ) {
      this.mandatoryFields = [
        'insurance'
      ]

      if (
        this.leadHistory.insurance &&
        this.leadHistory.insurance.name
      ) {
        if (this.leadHistory.insurance.name === "Não") this.mandatoryFields.push('insurance_refusal_reason')
        else if (this.leadHistory.insurance.name === "Sim") this.mandatoryFields.push('insurance_value')
      }
    }

  }

  private validateFields() {
    if (this.$auth.user().platform_name === 'portosegurocartoes') {
      const textFields = [
        'mother_name',
        'name_additional_1',
        'email2',
        'address',
        'number',
        'complement',
        'neighborhood'
      ]

      // accented letters not allowed
      const hasAccent = /[^a-zA-Z0-9\s'\(\)/!#$*+=\-_&@%,.]/g

      for (const field of textFields) {
        if (
          this.leadHistory &&
          this.leadHistory[field] &&
          hasAccent.test(this.leadHistory[field])
        ) {
          return this.$store.commit(
            "navBarAlert/WARNING_ALERT",
            `Acentos e alguns caracteres não são permitidos: ${this.leadHistory[field]}`
          )
        }
      }

      // convert accented letters in city names from list
      const selectFields = ['city', 'birth_city']

      for (const field of selectFields) {
        if (
          this.leadHistory &&
          this.leadHistory[field] &&
          typeof this.leadHistory[field] === 'string' &&
          hasAccent.test(this.leadHistory[field])
        ) {
          try {
            this.leadHistory[field] = this.leadHistory[field].normalize('NFD').replace(/[\u0300-\u036f]/g, "")
          } catch (err) {
            console.error(err)
          }
        }
      }
    }

    return true
  }

  private created() {
    this.leadService.show(this.idLead!).then((response) => {
      if (response["cl-wc-id_lead"]) {
        this.lead = {
          id_lead: response["cl-wc-id_lead"],
          id_platform: response["cp-wc-id_platform"],
          platform_name: response["cp-wc-name"],
          action_name: response["ca-wc-name"],
          content: response.content,
        };

        let phones = (({ phone, home_phone, phone3, phone4}) =>  ({ phone, home_phone, phone3, phone4 }))(this.lead.content);
        Object.keys(phones).forEach((key) => {
          if(!phones[key] || (typeof phones[key] === 'string' && phones[key] === ''))
            delete phones[key];
        });
        this.lead = Object.assign(
          this.lead,
          (({ email, name, phone, details, cpf, platform_lead_id, cnpj }) => ({
            email,
            name,
            phone,
            details,
            cpf,
            platform_lead_id,
            cnpj
          }))(this.lead.content)
        );
        if (this.isBvCardPlatform) {
          this.ufList = require('@/assets/json/brazil_states_uf.json');
          this.ufcities = require('@/assets/json/brazil_cities_in_states.json');
          this.nationalitiesList = require('@/assets/json/nationalities.json');
          this.bvInvoiceDates = require('@/assets/json/bv_invoice_due_dates.json');
          this.bvOccupationCodes = require('@/assets/json/bv_occupation_codes.json');
          this.bvCards = require('@/assets/json/bv_cc_and_insurance_code.json');

          this.cardBrandsList = this.bvCards.map(
            (item) => {
              return {
                name: item.name,
                label: item.label,
                code: item.brand_code,
              }
            }
          )

          if (this.lead && this.lead.content) {
            if (this.lead.content.state) {
              for (let i in this.ufList) {
                if (this.ufList[i].name == this.lead.content.state.toUpperCase()) {
                  this.homeState = this.ufList[i]
                }
              }
            }
            this.homeCitiesList = this.loadCities(this.homeState.index)
            if (this.homeCitiesList && this.lead.content.city) {
              // converting to upper case and removing punctuations, in order to compare if city name is correct/exists
              let contentCity = this.lead.content.city.toUpperCase().normalize('NFD').replace(/[\u0300-\u036f]/g, "")
              for (let i in this.homeCitiesList) {
                if (contentCity == this.homeCitiesList[i].toUpperCase().normalize('NFD').replace(/[\u0300-\u036f]/g, "")) {
                  this.homeCity = this.homeCitiesList[i]
                }
              }
            }
          }

          // split attribute address (26) into other attributes
          // if (this.lead.content.address) {
          //   let addressArray = this.lead.content.address.split(/\,\s|\s\-\s/, 3)
          //   this.homeStreetName = addressArray[0]
          //   this.homeNumber = addressArray[1]
          //   this.homeComplement = addressArray[2] ? addressArray[2] : null
          // }

          if (!!this.lead.content.birth_date) {
            if ( moment(this.lead.content.birth_date, 'YYYY-MM-DD', true).isValid() ) {
              this.birthDate = moment(this.lead.content.birth_date, 'YYYY-MM-DD').format('DD/MM/YYYY')
            } else if ( moment(this.lead.content.birth_date, moment.ISO_8601, true).isValid() ) {
              // in ISO_8601 case it's necessary to convert to string and slice, otherwise front-end will display date incorrectly due to timezone issues
              this.birthDate = moment(this.lead.content.birth_date, moment.ISO_8601).toISOString().slice(0, 10)
              this.birthDate = moment(this.lead.content.birth_date, 'YYYY-MM-DD').format('DD/MM/YYYY')
            } else if ( moment(this.lead.content.birth_date, 'DD/MM/YYYY', true).isValid() ) {
              this.birthDate = this.lead.content.birth_date
            } else {
              // if invalid or unknown format
              console.error('invalid or unknown birth_date format')
              this.birthDate = ''
            }
          }

          if (this.lead.content.income) {
            this.lead.content.income = String(this.lead.content.income).replace('.', '')
            this.lead.content.income = parseInt(this.lead.content.income) + ',00'
          }
        }

        if (this.$auth.user().platform_name === 'portosegurocartoes') {
          this.pscProfessions = require('@/assets/json/717_professions.json')
          this.simpleStatesAndCities = require('@/assets/json/br_states_and_cities.json')
        }

        this.lead.phones = Object.values(phones);

        if (!this.isBvProposition) {
          delete this.lead.content;
        }

        this.leadHistory.phone = phones.phone;
      }

      const channelService: ChannelService = new ChannelService();
      channelService.index().then((response) => {
        this.channels = ["dokcalcados-ortope", "bv-prevent-churn", 'wine', 'wine-upgrade', 'wine-reconquista', 'wine-refidelizacao', 'wine-cobranca'].includes(this.$auth.user().platform_name) ?
            response : response.filter((e) => e.name !== "app");
      });
      const statusService: StatusService = new StatusService();
      statusService.group(1).then((response) => {
        this.status = response.filter(e => !(["lead_pending", "lead_worked", "lead_self_finished_sale"].includes(e.name)))
      });
      const productService: ProductService = new ProductService();
      productService.indexStatus("product_ative").then((response) => {
        this.products = response;
      });

      const paymentService: PaymentService = new PaymentService();
      paymentService.index().then((response) => {
        this.paymentMethods = response;
      });

      const cpaService: CpaService = new CpaService();
      cpaService.index().then((response) => {
        this.valueCPA = response[0] && response[0].value ? response[0].value : undefined
        this.typeCPA = response[0] && response[0].trigger_type ? response[0].trigger_type: undefined
      });

      // To be implemented
      /*
        this.leadService.lastHistory(this.idLead!).then(response => {
          if (response) {
            this.leadHistory = response;
            this.editing = true;
          }
        });
       */

      this.loading = false;
    });
  }

  private submit(e) {
    if (!this.validateFields()) return false

    // Business rules conditional validations returning navBarAlert if not allowed
    if(!this.nameDisabled || !this.cpfDisabled || !this.cnpjDisabled || !this.phoneDisabled || !this.emailDisabled)
        return this.$store.commit("navBarAlert/WARNING_ALERT", `Error: Lead em edição, clique no botão check para salvar para depois tabular`);

    if (!this.leadHistory.phone || this.leadHistory.phone.length < 13)
      return this.$store.commit("navBarAlert/WARNING_ALERT", `Erro: telefone inválido!`);

    if ( this.leadHistory.date_scheduling == "" && this.leadHistory.status.name == "lead_scheduled")
        return this.$store.commit("navBarAlert/WARNING_ALERT", `Error: Data de agendamento é obrigatória!`);

    if (this.$auth.user().platform_name !== 'cantu'  && this.leadHistory.date_sale == "" && this.verticalVarejo.includes(this.$auth.user().platform_name) && this.leadHistory.status.name == "lead_finished_sale")
        return this.$store.commit("navBarAlert/WARNING_ALERT", `Error: Data de compra é obrigatória!`);

    if (!this.leadHistory.order && (this.$auth.user().platform_name == "farm") && this.leadHistory.status.name == "lead_finished_sale")
        return this.$store.commit("navBarAlert/WARNING_ALERT", `Error: Nº do pedido é obrigatório!`);

    if (!!this.leadHistory.order && !!this.lead.cpf && this.leadHistory.order == this.lead.cpf.replace(/\.|-/gm,''))
        return this.$store.commit("navBarAlert/WARNING_ALERT", `Error: Nº do pedido igual ao CPF`);

    if (this.leadHistory.status.name == "lead_finished_sale") {
      if (['bv', 'neon', 'stoodi', 'uaubox', 'portosegurocartoes', 'taglivros', 'queima-diaria'].includes(this.$auth.user().platform_name) &&
      (!this.leadHistory.product || this.leadHistory.product?.length == 0)) {
        return this.$store.commit("navBarAlert/WARNING_ALERT", `Error: Produto é obrigatório!`);
      }

      if (this.verticalVarejo.includes(this.$auth.user().platform_name) ||
      ['88iseguradora', 'empiricus-research', 'casaevideo', 'amedigital', 'ame-fgts', 'desincha', 'neon-fgts', 'queima-diaria'].includes(this.$auth.user().platform_name)) {
        if (!this.isValidSaleValue(this.leadHistory.value)) {
          this.loading = false;
          this.$store.commit("navBarAlert/WARNING_ALERT", `Erro: Valor de conversão não pode ser R$0,00!`);
          return false;
        }
      }

      if (
        this.leadHistory &&
        this.leadHistory.income &&
        !this.isValidIncome(this.leadHistory.income) &&
        this.leadHistory.status &&
        this.leadHistory.status.name === 'lead_finished_sale'
      ) {
        if (
          this.leadHistory.tabulation &&
          this.leadHistory.tabulation.name === 'Conversão coleta de dados' &&
          ['portosegurocartoes'].includes(this.$auth.user().platform_name)
        ) {
          this.loading = false;
          this.$store.commit("navBarAlert/WARNING_ALERT", `Erro: Valor da renda não pode ser R$0,00`);
          return false;
        }
      }

      if (this.leadHistory.date_renovation == "" && this.$auth.user().platform_name == "pravaler")
        return this.$store.commit("navBarAlert/WARNING_ALERT", `Error: Data da renovação é obrigatória!`);

      if (this.leadHistory.channel && this.leadHistory.channel.name == "app" && this.leadHistory.status && this.leadHistory.status.name !== "lead_scheduled")
        return this.$store.commit("navBarAlert/WARNING_ALERT", `Error: Não é possivel tabular canal app no painel!`);

      if (this.isBvCardPlatform) {
        if (!this.isValidBirthDate(this.birthDate) && this.isSaleActionName) {
          this.loading = false;
          this.$store.commit("navBarAlert/WARNING_ALERT", `Data de nascimento inválida`)
          return false;
        }

        if (this.lead.content && this.lead.content.income && !this.isValidIncome(this.lead.content.income)) {
          this.loading = false;
          this.$store.commit("navBarAlert/WARNING_ALERT", `Erro: Valor da renda não pode ser R$0,00!`);
          return false;
        }

        if (this.lead.content && this.lead.content.zipcode &&
        this.lead.content.zipcode.length < 10 ||
        (this.deliveryZipcode && this.deliveryZipcode.length < 10)) {
          this.loading = false;
          this.$store.commit("navBarAlert/WARNING_ALERT", `Erro: CEP inválido (8 dígitos necessários)`);
          return false;
        }
      }
    }

    if(e != undefined && e.type == 'submit')
        return this.$bvModal.show('modal-confirm');

    this.loading = true;
    this.$bvModal.hide('modal-verify');
    const save = e === true ? e : false;

    setTimeout(() => {
      this.$bvModal.hide('modal-confirm');
      if (!this.editing) {
        if (this.isWineUpgradePlan && this.clickedOnUpgradeButton) {
          this.wineUpgradePlan();
        } else if (this.isBvProposition && this.clickedOnPropositionButton) {
          // in this if, saveHistory is called inside bvProposition()
          this.bvProposition()
        } else {
          this.loading = true;
          this.saveHistory(save);
        }
      } else {
        // Update function to be implemented
        // this.leadService.updateLastHistory(this.idLead!, this.leadHistory).then(response => {
        //   console.log(response);
        //   this.loading = false;
        // });
      }
    }, 300);
  }

  private phoneSelected() {
    (this.$refs.phoneInput as any).$el.getElementsByClassName('vs__selected')[0].innerText = this.leadHistory.phone;
  }

}
